import { Component, EventEmitter, Output } from '@angular/core';
import { CheckboxComponent } from '../../../core/components/checkbox/checkbox.component';
import { InputComponent } from '../../../core/components/input/input.component';
import { FormsModule } from '@angular/forms';
import { DetectionOptions } from './options.interface';
import { SelectColorComponent } from '../select/select.component';

@Component({
  selector: 'app-options',
  standalone: true,
  imports: [
    CheckboxComponent,
    SelectColorComponent,
    InputComponent,
    FormsModule,
  ],
  templateUrl: './options.component.html',
  styleUrl: './options.component.css',
})
export class OptionsComponent {
  private options: DetectionOptions = {
    includeLabel: true,
    includeScore: true,
    color: null,
    threshold: '80',
  };

  @Output() optionsChange = new EventEmitter();

  label(val: boolean): void {
    this.options.includeLabel = val;
    this.optionsChange.emit(this.options);
  }

  score(val: boolean): void {
    this.options.includeScore = val;
    this.optionsChange.emit(this.options);
  }

  color(val: string): void {
    this.options.color = val;
    this.optionsChange.emit(this.options);
  }

  threshold(val: string): void {
    if (+val > 100) val = '100';
    if (val === '') val = '0';

    this.options.threshold = val;
    this.optionsChange.emit(this.options);
  }
}
